export const instrumentationSchema = {
  scenario: [
    {
      name: 'assetGrid',
      value: 'Asset Grid',
      activity: [
        {
          name: 'inlineEditRSAAsset',
          value: 'Inline Edit',
        },
        {
          name: 'inlineEditMMAAsset',
          value: 'Inline Edit',
        },
      ],
    }],
};
